import { render, staticRenderFns } from "./GoalManagement.vue?vue&type=template&id=c0551b28&scoped=true"
import script from "./GoalManagement.vue?vue&type=script&lang=js"
export * from "./GoalManagement.vue?vue&type=script&lang=js"
import style0 from "./GoalManagement.vue?vue&type=style&index=0&id=c0551b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0551b28",
  null
  
)

export default component.exports